// src/features/sheets/components/SpreadsheetHelpPanel.tsx
// Help panel component for spreadsheet formulas

import React from "react";

// ─────────────────────────────────────────────────────────────────────────────
// Component
// ─────────────────────────────────────────────────────────────────────────────

export const SpreadsheetHelpPanel: React.FC = () => {
  return (
    <div className="px-3 py-2 bg-slate-800/50 border-b border-slate-700/50 text-[10px] text-slate-400 flex-shrink-0 max-h-36 overflow-y-auto">
      <div className="grid grid-cols-3 gap-x-4 gap-y-1">
        <div>
          <span className="font-medium text-slate-300">Math:</span>
          <div>=A1+B1*2, =SUM(A1:A10)</div>
          <div>=AVERAGE, MIN, MAX, COUNT</div>
        </div>
        <div>
          <span className="font-medium text-slate-300">Logic:</span>
          <div>=IF(A1&gt;100, "Hi", "Lo")</div>
          <div>=ROUND(A1, 2)</div>
        </div>
        <div>
          <span className="font-medium text-emerald-400">Live Data:</span>
          <div>=LIVE("BTC", "price")</div>
          <div>
            =LIVE(A1, "price") <span className="text-slate-500">← cell ref!</span>
          </div>
        </div>
      </div>
      <div className="mt-1 text-slate-500">
        Metrics: price, mcap, volume, tvl, fees, revenue, change_1d, change_7d,
        change_30d, mc_to_tvl
      </div>
    </div>
  );
};

export default SpreadsheetHelpPanel;
